import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PicksReferenceService extends BaseReferenceService {
  constructor() {
    super('PicksReference');
  }
}
